var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashOperationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 18.7916H6.41667C3.66667 18.7916 1.83333 17.4166 1.83333 14.2083V7.79159C1.83333 4.58325 3.66667 3.20825 6.41667 3.20825H15.5833C18.3333 3.20825 20.1667 4.58325 20.1667 7.79159V14.2083C20.1667 17.4166 18.3333 18.7916 15.5833 18.7916Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.75C12.5188 13.75 13.75 12.5188 13.75 11C13.75 9.48122 12.5188 8.25 11 8.25C9.48122 8.25 8.25 9.48122 8.25 11C8.25 12.5188 9.48122 13.75 11 13.75Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83333 8.25008H2.75C5.5 8.25008 6.41667 7.33341 6.41667 4.58341V3.66675",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 8.25008H19.25C16.5 8.25008 15.5833 7.33341 15.5833 4.58341V3.66675",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83333 13.75H2.75C5.5 13.75 6.41667 14.6667 6.41667 17.4167V18.3333",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 13.75H19.25C16.5 13.75 15.5833 14.6667 15.5833 17.4167V18.3333",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashOperationsIcon);
export default __webpack_public_path__ + "static/media/cash-operations-icon.b47b07a04d3e2d548cdbdb287242e682.svg";
export { ForwardRef as ReactComponent };